import { z } from 'zod';

import { GoogleProductAndSku as NativeGoogleProductAndSku } from '@/common/graphql';

export const GoogleProductAndSKU = z.object({
  value: z.nativeEnum(NativeGoogleProductAndSku),
  displayName: z.string().default(''),
});
export type GoogleProductAndSKUType = z.infer<typeof GoogleProductAndSKU>;
